// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"778":"2485a896","789":"9edc27f4"}[chunkId] + ".css";
};